import { getCompany } from 'adminPanel/api/companies';
import { Company } from 'adminPanel/types';
import { useEffect, useState } from 'react';

export const useCompany = (companyId: number) => {
    const [company, setCompany] = useState<Company>();
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        getCompany(companyId)
            .then(setCompany)
            .finally(() => {
                setIsLoading(false);
            });
    }, []);

    return { company, isLoading };
};
